import { StorageManager } from 'src/app/common/storage-manager.class';
import { environment } from 'src/environments/environment';

export class EntradasEnvironmentDefinition {

    public readonly rol: string = String(StorageManager.getUser()?.rol ?? '');
    public readonly appName: string = String(environment.appName ?? '');
    public readonly applicationType: string = String(environment.features.applicationType ?? '');
    public readonly serverUrl: string = String(environment.serverUrl ?? '');
    public readonly empresaName: string = String(environment.features.empresaName ?? '');

    public readonly fincaName: string   = String(environment.features.fincaName   ?? 'Finca'  );
    public readonly sectorName: string  = String(environment.features.sectorName  ?? 'Sector' );
    public readonly parcelaName: string = String(environment.features.parcelaName ?? 'Parcela');
    public readonly clienteName: string = String(environment.features.clienteName ?? 'Cliente');

    public readonly userCanSeeClientes: boolean = Boolean(
        environment.features.userCanSeeClientes
    ) || this.rol === 'admin';

    public readonly showStockMarcaComercial: boolean = Boolean(environment.features.showStockMarcaComercial);
    public readonly showStockTipoDeDato: boolean = Boolean(environment.features.showStockTipoDeDato);
    public readonly showStockProveedor: boolean = Boolean(environment.features.showStockProveedor);
    public readonly showStockEnvase: boolean = Boolean(environment.features.showStockEnvase);
    public readonly showStockLotePropio: boolean = Boolean(environment.features.showStockLotePropio);
    public readonly showStockMotivo: boolean = Boolean(environment.features.showStockMotivo);
    public readonly showStockSemilla: boolean = Boolean(environment.features.showStockSemilla);
    public readonly showStockUbicacion: boolean = Boolean(environment.features.showStockUbicacion);
    public readonly showStockProveedorClienteDropdown: boolean = Boolean(environment.features.showStockProveedorClienteDropdown);
    public readonly showStockCifProveedor: boolean = Boolean(environment.features.showStockCifProveedor);
    public readonly persisteIdComercio: boolean = Boolean(environment.features.persisteIdComercio);
    public readonly hasStockParcelas: boolean = Boolean(environment.features.hasStockParcelas);
    public readonly showStockUbicacionDestino: boolean = Boolean(environment.features.showStockUbicacionDestino);
    public readonly showStockAdditionalFields: boolean = Boolean(environment.features.showStockAdditionalFields);
    public readonly hasPlantas: boolean = Boolean(environment.features.hasPlantas);

    public readonly columnasDistribucion: string = String(
        environment.features.showStockProductsColsDistribution ?? ''
    );

    public readonly columnasSemilla: string = this.appName === 'pyf'
        ? '6'
        : String(environment.features.showStockSemillasColsDistribution ?? '');


    public get maxRows(): number {
        if (this.appName === 'covidai' || this.appName === 'viverosblanco') {
            return 1;
        }

        return this.showStockAdditionalFields ? 5 : 3;
    }

    public get usesSinglePlantRow(): boolean {
        return this.appName === 'covidai' || this.appName === 'viverosblanco';
    }

    public get usesConselleriaLot(): boolean {
        return this.appName === 'bravosol' || this.appName === 'covidai';
    }

    public get forcesPlantType(): boolean {
        return this.appName === 'covidai' || this.appName === 'viverosblanco';
    }
}